import { useGlobals } from 'hooks/useGlobals';
import type { ProductSlug } from 'types/cms/ProductSlug';
import type { SanityProduct } from 'types/cms/SanityProduct';

export interface Collection {
  products: ProductSlug[];
}

export const useProductCollection = (
  collection?: Collection,
): SanityProduct[] => {
  const { data: globals } = useGlobals();

  if (!collection?.products.length) {
    return [];
  }

  const products = collection.products.map((product) =>
    globals.products.find(
      (globalProduct) => globalProduct?.slug === product?.slug,
    ),
  );

  return products.filter((product) => product !== undefined) as SanityProduct[];
};
